export default "__VITE_ASSET__BKcbjiq___"